import { useState } from 'react'

import { FormControl, Grid, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material'

import { Selects } from '../../reusableUI/Selects'
import { TextAreas } from '../../reusableUI/TextAreas'
import { Buttons } from '../../reusableUI/Buttons'

import { Settings } from '../../../models/settings'
import { useForm } from '../../../hooks/useForm2'
import { DialogUnidadNegocio } from '../unidad_negocios/DialogUnidadNegocio'
import { DialogFormaPago } from '../formas_pago/DialogFormaPago'
import { useSelector } from 'react-redux'

export const AjustesGenerales = ({ unitList, currencyList, listaFormasPagosVentas, detail }) => {

    const [openDialogUnidad, setOpenDialogUnidad] = useState(false)
    const [openDialogFormaPago, setOpenDialogFormaPago] = useState(false)
    const { listaTiposDocumentos } = useSelector(state => state.general)

    const { form, onInputChange } = useForm({
        id: detail.id,
        id_moneda: detail.id_moneda,
        id_forma_pago_venta: detail.id_forma_pago_venta,
        id_tipo_documento_venta: detail.id_tipo_documento_venta,
        id_area_negocio: detail.id_area_negocio,
        observaciones_ventas: detail.observaciones_ventas,
        no_incluye: detail.no_incluye,
        nombre_columna_dias: detail.nombre_columna_dias
    })

    const handleSubmit = async (e) => {
        e.preventDefault()
        console.log('form', form)
        await Settings.updateInfoPpto(form)
    }

    return (

        <div className="p-container-info-personal">

            <div className="row p-contet-title-info-personal">
                <div className="col-12">
                    <h3 className='text-start p-title-info-personal'>Ajustes predeterminados</h3>
                </div>
                <div className="col-12 p-text-info-personal">
                    <h6>Algunos datos se mostrarán por defecto al realizar un presupuesto de venta</h6>
                </div>
            </div>

            <form onSubmit={handleSubmit} className='mt-5'>

                <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                    <Grid item xs={12} sm={6}>
                        <Selects
                            label='Moneda por defecto'
                            name='id_moneda'
                            value={form.id_moneda}
                            data={currencyList}
                            onChange={onInputChange}
                            style={{ textTransform: 'uppercase' }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <Selects
                                label='Unidad de negocio por defecto'
                                name='id_area_negocio'
                                value={form.id_area_negocio}
                                data={unitList}
                                onChange={onInputChange}
                                style={{ textTransform: 'uppercase' }}
                            />
                            <Tooltip title="Agregar/modificar unidad de negocio">
                                <i
                                    className="bi bi-pencil ms-2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setOpenDialogUnidad(true)}
                                ></i>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <Selects
                                label='Forma de pago'
                                name='id_forma_pago_venta'
                                value={form.id_forma_pago_venta}
                                data={listaFormasPagosVentas}
                                onChange={onInputChange}
                                style={{ textTransform: 'uppercase' }}
                            />
                            <Tooltip title="Agregar/modificar formas de pago">
                                <i
                                    className="bi bi-pencil ms-2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setOpenDialogFormaPago(true)}
                                ></i>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                            <Select
                                label="Tipo de documento"
                                id="id_tipo_documento_venta"
                                name="id_tipo_documento_venta"
                                value={form.id_tipo_documento_venta}
                                onChange={onInputChange}
                                style={{ textTransform: 'uppercase' }}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaTiposDocumentos.map(item => (
                                    <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <TextAreas
                            label="Observaciones"
                            name="observaciones_ventas"
                            value={form.observaciones_ventas || ''}
                            onChange={onInputChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextAreas
                            label="No Incluye"
                            name="no_incluye"
                            value={form.no_incluye || ''}
                            onChange={onInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Nombre columna días"
                            name="nombre_columna_dias"
                            id="outlined-size-small"
                            value={form.nombre_columna_dias || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese nombre columna'
                            onChange={onInputChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <div>
                            <Buttons
                                label='Guardar cambios'
                                type='submit'
                            />
                        </div>
                    </Grid>

                </Grid>

            </form>

            {openDialogUnidad &&
                <DialogUnidadNegocio
                    open={openDialogUnidad}
                    setOpen={setOpenDialogUnidad}
                />
            }

            {openDialogFormaPago &&
                <DialogFormaPago
                    open={openDialogFormaPago}
                    setOpen={setOpenDialogFormaPago}
                    origen="ventas"
                />
            }

        </div>

    )
}